import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import store from '../store/index.js';

// silence those nasty nav duplicated exceptions w/out need to import the err instance and do a bunch of checks
const ctx = Router.prototype.push;

Router.prototype.push = function push (loc) {
  return ctx
    .call(this, loc)
    .catch(() => {});
};

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history', // hash or history
  linkActiveClass: 'active',
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

// Global route guard
router.beforeEach((to, from, next) => {
  const e = localStorage.getItem('environment') || null;

  if (to.path !== '/' && (e === null || e === '')) return next();

  if (!to.matched.some(record => record.meta.requiresAuthentication)) next();

  const isSignedIn = store.getters['auth/isUserSignedIn'];

  if (!isSignedIn) return next({ path: '/signin' });

  return next();
});

export default router;
